"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./InputRadioButton.scss");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _index = require("../../../index");

var _InputErrorMessage = require("../InputErrorMessage");

var _InputErrorMessage2 = _interopRequireDefault(_InputErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var rootClass = 'c-InputRadioButton';

var InputRadioButton =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(InputRadioButton, _PureComponent);

  function InputRadioButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, InputRadioButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(InputRadioButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getErrorClass = function () {
      return _this.props.error ? "".concat(rootClass, "--error") : '';
    };

    return _this;
  }

  _createClass(InputRadioButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          error = _this$props.error,
          values = _this$props.values,
          errorMessage = _this$props.errorMessage,
          groupName = _this$props.groupName,
          onChange = _this$props.onChange;
      var activeClasseNames = [rootClass, this.getErrorClass()].filter(Boolean).join(' ');
      return _react2.default.createElement("div", null, _react2.default.createElement(_InputErrorMessage2.default, {
        id: "".concat(name, "ErrorMessage"),
        error: error,
        errorMessage: errorMessage
      }), values.map(function (val, index) {
        return _react2.default.createElement(_index.Label, {
          className: activeClasseNames,
          key: "RadioButton_[".concat(index, "]")
        }, _react2.default.createElement("input", {
          id: "RadioButton_".concat(groupName, "_").concat(val.value),
          type: "radio",
          value: val.value,
          name: groupName,
          onChange: onChange
        }), val.label);
      }));
    }
  }]);

  return InputRadioButton;
}(_react.PureComponent);

InputRadioButton.propTypes = {
  values: _propTypes2.default.array,
  error: _propTypes2.default.bool,
  errorMessage: _propTypes2.default.string,
  groupName: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};
exports.default = InputRadioButton;